import AtomsStyles from 'saur_ui_library/src/Atoms/Styles';
import MoleculesStyles from 'saur_ui_library/src/Molecules/Styles';
import OrganismsStyles from 'saur_ui_library/src/Organisms/Styles';
import GlobalFonts from 'saur_ui_library/src/Common/GlobalFonts';
import GlobalStyles from 'saur_ui_library/src/Common/GlobalStyles';
import ResetInputs from 'saur_ui_library/src/Common/ResetInputs';
import ResetMeyer from 'saur_ui_library/src/Common/ResetMeyer';
import React from 'react';
import { useTheme } from 'styled-components';
import { fonts } from 'saur_ui_library/src/Theme';

const ResetStyleComponent = () => {
  const theme = {theme: useTheme()};
  return (
      <ContentWithTheme {...theme} {...fonts} />
  );
};

const ContentWithTheme = (theme, fonts) => {
  return (
    <>
      <GlobalFonts {...fonts} />
      <GlobalStyles />
      <ResetInputs />
      <ResetMeyer />
      <AtomsStyles {...theme} />
      <OrganismsStyles {...theme} />
      <MoleculesStyles {...theme} />
    </>
  );
};

export default ResetStyleComponent;